/* eslint-disable no-underscore-dangle */
/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint-disable camelcase */
/* eslint no-console: ["error", { allow: ["debug", "error"] }] */
const NA = 'n/a';
const vitamin = {
  global: {
    'page_name': '',
    'page_division_section': '',
    'page_site_section': '',
    'page_sub_section': '',
    'page_type': '',
    'code_version': '1.1.0',
    'customer_status': '',
    'page_content_id': '',
    'page_content_type': '',
    'deployment_instance': '',
    'cookie_consent_approved': '',
  },
  customer: {
    'customer_cpr': '',
    'customer_cvr': '',
    'customer_address_floor': '',
    'customer_address_door': '',
    'customer_address_house_number': '',
    'customer_address_streetname': '',
    'customer_address_string': '',
    'customer_address_zipcode': '',
    'customer_email_address': '',
    'customer_mobile_phone_number': '',
    'customer_private_phone_number': '',
    'customer_products': '',
    'customer_work_phone_number': '',
    'customer_ff_number': '',
    'customer_residence_type': '',
    'customer_residence_ownership': '',
    'customer_household_members': '',
    'customer_household_children': '',
    'customer_has_car': '',
  },
  fakeFlow: {
    'custom_event': ['fake flow start'],
    'product_id': '',
    'product_category': '',
  },
  internalSearch: {
    'custom_event': ['internal search'],
    'search_internal_term': '',
    'search_internal_results': '',
  },
  leadForms: {
    'flow_step_no': '',
    'flow_name': '',
    'flow_category': '',
    'lead_form_name': '',
    'lead_product_category': '',
  },
  leadFormsStart: {
    'custom_event': ['lead form start'],
  },
  leadFormsComplete: {
    'custom_event': ['lead form complete'],
  },
  login: {
    'login_role': '',
    'login_location': '',
    'login_method': '',
  },
  loginSuccessful: {
    'custom_event': ['login success'],
    'login_role': '',
    'login_location': '',
    'login_method': '',
    'login_timestamp': '',
  },
  loginFailed: {
    'custom_event': ['login fail'],
    'login_method': '',
    'error_message': '',
    'error_type': '',
    'error_code': '',
  },
  profileSectionUpdate: {
    'custom_event': ['profile update'],
    'customer_profile_update_description': '',
  },
  insuranceView: {
    'custom_event': ['view insurance details'],
  },
  insuranceEdit: {
    'custom_event': ['update insurance complete'],
    'purchase_additional_covers': 'cover1|cover2',
  },
  subscriptionChange: {
    'custom_event': ['product subscription change'],
    'customer_subscription_change': 'månedlig',
  },
  subscriptionCancel: {
    'custom_event': ['cancel subscription complete'],
    'product_cancel_reason': '',
  },
  documentView: {
    'custom_event': ['view insurance document'],
    'document_type': '',
  },
  documentDownload: {
    'custom_event': ['download insurance document'],
    'document_type': '',
  },
  product: {
    'product_category': '',
    'page_product_name': '',
  },
  productView: {
    'custom_event': ['product details page'],
  },
  checkoutCalculation: {
    'flow_step_no': '',
    'flow_group': '',
    'flow_category': '',
    'flow_name': '',
    'product_category': '',
    'page_type': '',
  },
  checkoutCalculationStart: {
    'custom_event': ['checkout calc start'],
  },
  checkoutCalculationComplete: {
    'custom_event': ['checkout calc complete'],
  },
  checkoutSaveOffer: {
    'custom_event': ['retrieve offer'],
  },
  retrieveOffer: {
    'custom_event': ['retrieve offer'],
  },
  checkoutCalculationOrder: {
    'purchase_product_id': '',
    'additional_covers': '',
  },
  checkoutOrderStart: {
    'custom_event': ['order start'],
    'flow_step_no': '',
  },
  checkoutConfirmation: {
    'custom_event': ['order complete'],
    'purchase_id': '',
    'purchase_revenue': '',
    'purchase_total_discount': '',
    'purchase_payment_frequency': '',
    'purchase_payment_method': '',
    'purchase_product_units': '',
  },
  internalOffers: {
    'custom_event': ['impression page internal offer'],
    'page_internal_offers': '',
  },
  internalOffersClick: {
    'custom_event': ['click page internal offer'],
    'page_internal_offers': '',
  },
  error: {
    'custom_event': ['system error'],
    'error_type': 'system error',
    'error_code': '',
  },
  error500: {
    'custom_event': ['error 500'],
  },
  error404: {
    'custom_event': ['404 error'],
  },
  internalSearchLink: {
    'custom_event': ['internal search result click'],
    'search_internal_position': '',
  },
  industryBundleForm: {
    'custom_event': ['business category search'],
  },
  commercialGuideContactLink: {
    'custom_event': ['business category search complete'],
  },
  getProperty(key) {
    return this[key] ? JSON.parse(JSON.stringify(this[key])) : undefined;
  },
  /**
   * Process data with data mapping and lowercase.
   *
   * @param {array} keys
   * @param {Object} dataMapping
   * @param {Object} data
   */
  processData(keys, dataMapping, data) {
    // Data mapping based on keys
    keys.forEach((key) => {
      this.mapDefaultProperties(this[key], data, dataMapping);
    });
    this.mapToLowercase(data);
  },
  /**
   * Send utag data with link.
   * Returns true if utag is available else it will return false.
   *
   * @param {array} keys
   * @param {Object} dataMapping
   * @param {Object} data
   */
  link(keys, dataMapping, data) {
    // Set the data if it has not been defined.
    // data = typeof data === 'undefined' ? {} : data;
    const requestData = typeof data === 'undefined' ? {} : data;
    this.processData(keys, dataMapping, requestData);
    this.sendLink(requestData);
  },
  /**
   * Send utag link.
   *
   * @param data
   */
  sendLink(data) {
    const that = this;
    if (typeof window.utag !== 'undefined') {
      window.utag.link(data);
    } else {
      // Try again later.
      setTimeout(() => {
        that.sendLink(data);
      }, 50);
    }
  },
  /**
   * Send utag data with view with lowercase and mapping of data..
   * Returns true if utag is available else it will return false.
   *
   * @param {array} keys
   * @param {Object} dataMapping
   * @param {Object} requestData
   */
  view(keys, dataMapping, requestData) {
    // Set the data if it has not been defined.
    const data = typeof requestData === 'undefined' ? {} : requestData;
    data.page_name = this.getPageName(dataMapping, data);
    this.processData(keys, dataMapping, data);
    // Remove specific field if like empty.
    if (data.additional_covers && data.additional_covers.length === 1 && data.additional_covers[0] === '') {
      delete data.additional_covers;
    }
    if (data.purchase_total_discount && data.purchase_total_discount === '0') {
      delete data.purchase_total_discount;
    }
    // Append flow group if its there.
    const appendFlowGroup = data._append_flow_group;
    if (appendFlowGroup) {
      if (data.flow_group && data.flow_group.indexOf(appendFlowGroup) === -1) {
        data.flow_group += ` ${appendFlowGroup}`;
      }
      delete data._append_flow_group;
    }
    // Logic to handle customer status dynamically as drupal node is cached.
    if (data.customer_status && this.readCookie('lg_status') === 'success') {
      data.customer_status = 'logget ind';
    } else {
      data.customer_status = 'ikke logget ind';
    }
    delete data._page_title;
    if (data._append_title) {
      delete data._append_title;
    }
    if (typeof dataMapping.mock === 'undefined' || !dataMapping.mock) {
      this.sendView(data);
    } else {
      console.debug('It is Mock service.....');
    }
    return data;
  },
  /**
   * Send utag view.
   *
   * @param {Object} data
   */
  sendView(data) {
    const that = this;
    if (typeof window.utag !== 'undefined' && typeof window.utag.view !== 'undefined') {
      if (typeof window.utag_data === 'undefined') {
        window.utag_data = {};
      }
      Object.keys(data).forEach(key => {
        window.utag_data[key] = data[key];
      });
      if (!data.cookie_consent_approved || data.cookie_consent_approved.length === 0) {
        data.cookie_consent_approved = window.utag_data.cookie_consent_approved;
      }
      window.utag.view(data);
      if (typeof QSI !== 'undefined') {
        // Make qualtrics see as a new page load.
        // eslint-disable-next-line no-undef
        QSI.API.unload();
        // eslint-disable-next-line no-undef
        QSI.API.load();
      }
    } else {
      setTimeout(() => {
        that.sendView(data);
      }, 50);
    }
  },
  /**
   * @param object
   * @returns {string|*[]|*}
   */
  toLowerCase(object) {
    if (typeof object === 'string' || object instanceof String) {
      return object.toLowerCase();
    }
    if (object instanceof Array) {
      return object.map((item) => {
        return this.toLowerCase(item);
      });
    }
    return object;
  },
  /**
   * Set strings in array to lower case.
   *
   * @param {Object} data
   */
  mapToLowercase(data) {
    if (data !== undefined) {
      Object.keys(data).forEach(key => {
        data[key] = this.toLowerCase(data[key]);
      });
      /* for (const prop in data) {
        data[prop] = this.toLowerCase(data[prop]);
      } */
    }
  },
  /**
   * Set data from defaultMap and mapped with dataMapping.
   *
   * @param {Object} defaultMap
   * @param {Object} data
   * @param {Object} dataMapping
   */
  mapDefaultProperties(defaultMap, data, dataMapping) {
    Object.keys(defaultMap).forEach(prop => {
      if (data[prop] === undefined) {
        if (defaultMap[prop] === '' && dataMapping[prop] !== undefined && dataMapping[prop] !== '' && dataMapping[prop] !== null) {
          data[prop] = dataMapping[prop];
        } else if (defaultMap[prop] !== undefined && defaultMap[prop] !== '') {
          const find = /\$\[(.*?)\]\]?/g;
          if (typeof defaultMap[prop] === 'string' && defaultMap[prop].match(find) && dataMapping) {
            // Allow for one level of token in token like
            // $[topLevel$[subLevel]].
            defaultMap[prop].match(find).map((token) => {
              const newProp = token.replace(find, '$1');
              data[prop] = typeof dataMapping[newProp] !== 'undefined' ? dataMapping[newProp] : '';
              return true;
            });
          } else {
            data[prop] = defaultMap[prop];
          }
        }
      }
    });
  },
  getPageName(dataMapping, data) {
    const deploymentInstance = data.deployment_instance ?
      data.deployment_instance : dataMapping.deployment_instance;
    if (typeof deploymentInstance === 'undefined') {
      console.error('No deployment instance data for tracking');
    }
    const pageDivisionSection = data.page_division_section
      ? data.page_division_section
      : dataMapping.page_division_section;
    if (typeof pageDivisionSection === 'undefined') {
      console.error('No page division section data for tracking');
    }
    let pageName = `${deploymentInstance} | ${pageDivisionSection}`;
    let pageTitle = data._page_title ? data._page_title : dataMapping._page_title;
    if (!pageTitle) {
      pageTitle = NA;
    }
    const pageSiteSection = data.page_site_section ?
      data.page_site_section : dataMapping.page_site_section;
    if (pageSiteSection && pageSiteSection !== pageTitle && pageSiteSection !== NA) {
      pageName += ` | ${pageSiteSection}`;
    }
    const pageSubSection = data.page_sub_section ?
      data.page_sub_section : dataMapping.page_sub_section;
    if (pageSubSection && pageSubSection !== pageTitle &&
      pageSubSection !== pageSiteSection && pageSubSection !==
      NA) {
      pageName += ` | ${pageSubSection}`;
    }
    pageName += ` | ${pageTitle}`;
    const appendTitle = data._append_title ? data._append_title : dataMapping._append_title;
    if (appendTitle) {
      pageName += ` | ${appendTitle}`;
    }
    const flowStepNo = data.flow_step_no ? data.flow_step_no : dataMapping.flow_step_no;
    if (flowStepNo && flowStepNo !== NA && flowStepNo !== 'stepfinish') {
      pageName += ` | ${flowStepNo}`;
    }
    return pageName;
  },
  readCookie(a) {
    const d = [];
    const e = document.cookie.split(';');
    const cookieName = RegExp(`^\\s*${a}=\\s*(.*?)\\s*$`);
    for (let b = 0; b < e.length; b++) {
      const f = e[b].match(cookieName);
      if (f) {
        d.push(f[1]);
      }
      // f && d.push(f[1])
    }
    return d.length > 0 ? d[0] : null;
  },
};
/** exposed functions */
export const trygTealiumLib = {
  /**
   * Send utag data with link.
   * Returns true if utag is available else it will return false.
   *
   * @param {Array<string>} keys
   * @param dataMapping
   * @param data
   */
  link: (keys, dataMapping, data = {}) => {
    vitamin.processData(keys, dataMapping, data);
    vitamin.sendLink(data);
  },
  /**
   * Send utag data with view with lowercase and mapping of data..
   * Returns true if utag is available else it will return false.
   *
   * @param {Array<string>} keys
   * @param dataMapping
   * @param data
   */
  view(keys, dataMapping, data = {}) {
    return vitamin.view(keys, dataMapping, data);
    // vitamin.processData(keys, dataMapping, data);
    // vitamin.sendView(dataMapping, data);
  },
};

